module.exports = __webpack_public_path__ + "img/5.39d0115c.png";